import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Box,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export default function FilterDropdown({
  value,
  onChange,
  options = [],
  label = "Filter",
  placeholder = "All",
  fullWidth = false,
  variant = "outlined",
  size = "medium",
  sx = {},
}) {
  return (
    <FormControl
      fullWidth={fullWidth}
      variant={variant}
      size={size}
      sx={{
        bgcolor: "white",
        borderRadius: 1,
        "& .MuiOutlineInput-root": {
          borderRadius: 1,
        },
        ...sx,
      }}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        label={label}
        IconComponent={KeyboardArrowDownIcon}
      >
        <MenuItem value="">
          <em>{placeholder}</em>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.item.id} value={option.item.value}>
            {option.item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}